/*
	copyright 2019 sg
	Aus den Funktionen in desem File wird Wolframs RenderSector function aufgerufen.
	Hier wird geschaut, welche Sektoren benoetigt werden. Ob das Dreieck im oder gegen den Uhrzeigersinn
	gezeichnet ist. Hier werden die temporaeren Sektoren gemalt und die finalen.
*/

import rhumbBearing from '@turf/rhumb-bearing';

import {Feature} from 'ol';
import {LineString} from 'ol/geom';

import point from './point';
import renderSector from './render-sector';
import transform, {EPSG3857, EPSG4326} from './transform';

const addFeatures = (sector, latA, lonA, latB, lonB) => {
    const points = renderSector(latA, lonA, latB, lonB);
    const lines = points.length / 21;

    for (let i = 0; i < lines; i++) {
        const line = points.slice(i * 21, (i + 1) * 21);
        const polyline = new LineString(line);
        polyline.transform(EPSG4326, EPSG3857);
        sector.addFeature(new Feature(polyline));
    }
};

const drawTempSector = (sector, coords) => {
    sector.clear();

    const lonLatStart = transform(coords[0]);
    const lonLatZiel = transform(coords[1]);

    const startLatRad = degreesToRadians(lonLatStart[1]);
    const startLonRad = degreesToRadians(lonLatStart[0]);
    const zielLatRad = degreesToRadians(lonLatZiel[1]);
    const zielLonRad = degreesToRadians(lonLatZiel[0]);

    addFeatures(sector, startLatRad, startLonRad, zielLatRad, zielLonRad);
    addFeatures(sector, zielLatRad, zielLonRad, startLatRad, startLonRad);
};

const addAllFeatures = (sector, start, dest) => {
    start = transform(start);
    dest = transform(dest);

    return addFeatures(
        sector,
        degreesToRadians(start[1]),
        degreesToRadians(start[0]),
        degreesToRadians(dest[1]),
        degreesToRadians(dest[0]),
    );
};

// coords ist ein Array mit allen Feature Punkte (Eckkoordinaten) in Rad
function drawAllSectors(sector, coords) {
    sector.clear();

    // Je nachdem ob im oder gegen Uhrzeigersinn, muss entsprechend unterschieden werden.
    const isClockWise = getClockDir(coords);

    if (isClockWise) {
        for (let k = 0; k < 3; k++) {
            addAllFeatures(sector, coords[k], coords[k + 1]);
        }
    } else {
        for (let k = 3; k > 0; k--) {
            addAllFeatures(sector, coords[k], coords[k - 1]);
        }
    }
}

const PI_180 = Math.PI / 180;

// Umrechnen von Radians in Degrees
const degreesToRadians = degrees => degrees * PI_180;

function getClockDir(coords) {

    /*
        Check, ob Dreieck im oder gegen den Uhrzeigersinn
        Dazu ist das Bearing von Schenkel 1 und Schenkel 2 notwendig
    */

    const point1 = point(coords[0]);
    const point2 = point(coords[1]);
    const point3 = point(coords[2]);

    const bearingLeg1A = rhumbBearing(point1, point2);
    const bearingLeg2A = rhumbBearing(point2, point3);

    let bearingAngle = bearingLeg1A - bearingLeg2A;

    if (bearingAngle > 180) {
        bearingAngle -= 360;
    } else if (bearingAngle < -180) {
        bearingAngle += 360;
    }

    return bearingAngle < 0;
}

export {drawTempSector, drawAllSectors};
